"use client";

import { useFormStatus } from "react-dom";

type Props = {
  children: React.ReactNode;
  pendingLabel?: string;
  className?: string;
};

export default function SubmitButton({ children, pendingLabel, className }: Props) {
  const { pending } = useFormStatus();
  return (
    <button
      type="submit"
      disabled={pending}
      className={
        className ??
        "bg-rose-600 hover:bg-rose-700 disabled:opacity-60 text-white rounded-lg px-5 py-2.5 text-sm font-medium"
      }
    >
      {pending ? (pendingLabel ?? "…") : children}
    </button>
  );
}
